"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _AwayStatusIndicator = _interopRequireDefault(require("./AwayStatusIndicator"));
var _SocialLinks = _interopRequireDefault(require("./SocialLinks"));
var _UserAvatar = _interopRequireDefault(require("./UserAvatar"));
var _default = exports.default = {
  components: {
    AwayStatusIndicator: _AwayStatusIndicator.default,
    SocialLinks: _SocialLinks.default,
    UserAvatar: _UserAvatar.default
  },
  props: ['network'],
  data() {
    return {
      is_usermenu_open: false
    };
  },
  computed: {
    getUser() {
      if (this.network && this.network.state && this.network.currentUser()) {
        return this.network.currentUser();
      }
      return null;
    },
    isConnected() {
      return this.network && this.network.state === 'connected';
    },
    socialLinks() {
      let s = this.$state.settings.startupOptions.socialLinks;
      return typeof s === 'object' && s !== null ? s : {};
    }
  },
  methods: {
    clickForget() {
      let msg = 'This will delete all stored networks and start fresh. Are you sure?';
      /* eslint-disable no-restricted-globals, no-alert */
      let confirmed = confirm(msg);
      if (!confirmed) {
        return;
      }
      this.$state.persistence.forgetState();
      window.location.reload();
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["StateBrowserUsermenu"]
window._kiwi_exports.components.StateBrowserUsermenu = exports.default ? exports.default : exports;
